var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "login-page-container",
      attrs: {
        a_id: "edit-password-container",
        "extension-name": "reset-password"
      }
    },
    [
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showPasswordGuideline,
              expression: "showPasswordGuideline"
            }
          ],
          staticClass: "edit-password-guideline",
          attrs: { a_id: "edit-password-guideline" }
        },
        [
          _vm._v("\n\t\tPassword must include:"),
          _c("br"),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "edit-password-guideline-rule",
              attrs: { a_id: "edit-password-guideline-1" }
            },
            [_vm._v("> At least 8 characters long")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "edit-password-guideline-rule",
              attrs: { a_id: "edit-password-guideline-2" }
            },
            [_vm._v("> At least 1 number")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "edit-password-guideline-rule",
              attrs: { a_id: "edit-password-guideline-3" }
            },
            [_vm._v("> Uppercase alphabetic chars")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "edit-password-guideline-rule",
              attrs: { a_id: "edit-password-guideline-4" }
            },
            [_vm._v("> Lowercase alphabetic chars")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "edit-password-guideline-rule",
              attrs: { a_id: "edit-password-guideline-5" }
            },
            [_vm._v("> At least 1 special char")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "login-page-header",
          attrs: { a_id: "edit-password-header" }
        },
        [
          _vm._v("\n\t\t" + _vm._s(_vm._f("translate")(_vm.title)) + " "),
          _c("b", [
            _vm._v(
              _vm._s(
                _vm._f("translate")("EditPasswordPage.EditPasswordHeaderEnd")
              )
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "edit-password-description",
          attrs: { a_id: "edit-password-description" }
        },
        [
          _vm._v(
            "\n\t\t" +
              _vm._s(
                _vm._f("translate")("EditPasswordPage.EditPasswordDecription")
              ) +
              "\n\t"
          )
        ]
      ),
      _vm._v(" "),
      _c("login-page-field", {
        attrs: {
          title: _vm._f("translate")("LoginPage.Password"),
          type: "password",
          placeholder: _vm._f("translate")(
            "EditPasswordPage.PasswordPlaceholderRequired"
          ),
          "image-type": "password",
          "show-password-strength": _vm.password,
          a_id: "edit-password-field-password-1"
        },
        on: {
          focus: function($event) {
            return _vm.setShowPasswordGuideline(true)
          },
          blur: function($event) {
            return _vm.setShowPasswordGuideline(false)
          },
          enter: _vm.resetClicked,
          passwordStrong: _vm.setPasswordStrength
        },
        model: {
          value: _vm.password,
          callback: function($$v) {
            _vm.password = $$v
          },
          expression: "password"
        }
      }),
      _vm._v(" "),
      _c("login-page-field", {
        attrs: {
          title: _vm._f("translate")("LoginPage.PasswordRetypeTitle"),
          type: "password",
          placeholder: _vm._f("translate")(
            "EditPasswordPage.RetypePasswordPlaceholderRequired"
          ),
          "image-type": "password_retype",
          "show-error-message":
            (_vm.loginFailed || !_vm.validateBothPasswordsMatch()) &&
            !!_vm.password2,
          "error-message": _vm._f("translate")(
            _vm.errorMessage || "LoginPageField.PasswordStrengthErrorMessage"
          ),
          a_id: "edit-password-field-password-2"
        },
        on: { enter: _vm.resetClicked, focus: _vm.setSecondPasswordActivated },
        model: {
          value: _vm.password2,
          callback: function($$v) {
            _vm.password2 = $$v
          },
          expression: "password2"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "login-page-footer",
          attrs: { a_id: "edit-password-footer" }
        },
        [
          _vm.resetButtonEnabled
            ? _c(
                "button",
                {
                  staticClass: "login-page-footer-button-right",
                  attrs: { a_id: "edit-password-footer-reset-button" },
                  on: { click: _vm.resetClicked }
                },
                [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(_vm._f("translate")("LoginPage.ResetPassword")) +
                      "\n\t\t"
                  )
                ]
              )
            : _c(
                "button",
                {
                  staticClass: "login-page-footer-button-right",
                  attrs: {
                    disabled: "",
                    a_id: "edit-password-footer-reset-button-disabled"
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm._f("translate")(_vm.buttonTitle)) + "\n\t\t"
                  )
                ]
              )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ba9af9b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ba9af9b","hasScoped":false,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/EditPasswordPage.vue
// module id = 450
// module chunks = 0